// Los interruptores del módulo de Calidad, fuera del archivo de la
// pantalla.
//
// No es purismo: un archivo que exporta un componente Y otras cosas rompe
// la recarga en caliente de Vite para todo el archivo. Es exactamente el
// motivo por el que `contextoAuth` vive en `lib/` y el vocabulario de
// documentos en `ui/documentos.js`.
//
// LOS TRES INTERRUPTORES, en el orden en que se encienden de verdad.
//
// NO ES ALFABÉTICO NI EL ORDEN DE LAS FASES: es el orden en que una
// planta los enciende. Primero se captura de dónde viene el material,
// luego se retiene lo que llega, y solo al final —cuando ya hay quien
// inspeccione— se cierra la puerta del embarque. Encender el tercero
// antes que el segundo deja una empresa que no puede vender y no sabe
// por qué.
export const INTERRUPTORES = [
  {
    campo: 'exigir_lote_proveedor',
    titulo: 'Exigir el lote del proveedor al recibir',
    queCambia: 'Al recibir productos que manejan lotes, el lote del proveedor será obligatorio.',
    siApagado: 'Con esto apagado el campo sigue estando, pero se puede dejar en blanco (es como funcionaba antes).',
    alEncender: 'Listo. A partir de ahora no se puede recibir material sin decir de qué lote del proveedor viene.',
    alApagar: 'Listo. El lote del proveedor vuelve a ser opcional al recibir.',
  },
  {
    campo: 'lote_nace_en_cuarentena',
    titulo: 'Retener el material que llegue, hasta que alguien lo revise',
    queCambia: 'Cada lote nuevo queda RETENIDO al recibirlo, hasta que una inspección de recibo lo libere.',
    siApagado: 'Con esto apagado, el material que llega queda liberado desde el primer momento.',
    alEncender: 'Listo. El material que llegue a partir de ahora queda retenido hasta que alguien lo revise. Lo que ya está en el almacén no se toca.',
    alApagar: 'Listo. El material que llegue vuelve a quedar liberado desde el primer momento.',
  },
  {
    campo: 'exigir_liberacion',
    titulo: 'No dejar que salga nada sin liberar',
    queCambia: 'Una venta de un lote que no esté liberado se rechaza, y se dice por qué.',
    siApagado: 'Con esto apagado, el estado de calidad se registra pero no frena ninguna venta.',
    alEncender: 'Listo. A partir de ahora no sale un lote que no esté liberado. Revisa antes que no te quede mercancía retenida sin poder revisar.',
    alApagar: 'Listo. El estado de calidad se sigue registrando, pero ya no frena las ventas.',
  },
];

// El mismo juicio que hace el servidor, repetido aquí SOLO para pintar en
// vivo mientras se teclea. LO QUE VALE ES EL DEL SERVIDOR: éste no viaja
// a ninguna parte y si algún día los dos discreparan, el que manda es
// aquél. Se repite porque esperar a guardar para enterarte de que la
// cota está fuera es lo que hace que se capturen veinte medidas malas.
export function juzgar(c, valor, atributo) {
  if (c.clase === 'ATRIBUTO') return atributo ? 'OK' : 'NOK';
  if (valor === '' || valor === null || Number.isNaN(Number(valor))) return null;
  if (c.nominal === null || c.nominal === undefined) return 'OK';
  const v = Number(valor);
  const base = Number(c.nominal);
  const inf = c.tolerancia_inferior;
  const sup = c.tolerancia_superior;
  if (inf === null && sup === null) return 'OK';
  if (inf !== null && inf !== undefined && v < base + Number(inf)) return 'NOK';
  if (sup !== null && sup !== undefined && v > base + Number(sup)) return 'NOK';
  return 'OK';
}

export function rangoDe(c) {
  if (c.clase !== 'VARIABLE' || c.nominal === null || c.nominal === undefined) return null;
  const u = c.unidad ? ` ${c.unidad}` : '';
  const inf = c.tolerancia_inferior;
  const sup = c.tolerancia_superior;
  if (inf === null && sup === null) return `Debe medir ${c.nominal}${u}`;
  const min = inf !== null && inf !== undefined ? Number(c.nominal) + Number(inf) : null;
  const max = sup !== null && sup !== undefined ? Number(c.nominal) + Number(sup) : null;
  if (min !== null && max !== null) {
    return `Vale de ${+min.toFixed(4)} a ${+max.toFixed(4)}${u}`;
  }
  if (min !== null) return `No menos de ${+min.toFixed(4)}${u}`;
  return `No más de ${+max.toFixed(4)}${u}`;
}


// ---------------------------------------------------------------------
// CALIDAD · Fase 4 · vocabulario de las no conformidades
// ---------------------------------------------------------------------
// EN ESPAÑOL LLANO Y NO EN EL DE LA NORMA. «Disposición del material no
// conforme» es como se llama en un manual de calidad; «qué se hizo con
// el material» es como lo pregunta quien tiene la tarima delante.
export const ORIGENES_NC = [
  ['RECIBO', 'Lo detectamos al recibir material'],
  ['PROCESO', 'Lo detectamos fabricando'],
  ['FINAL', 'Lo detectamos antes de embarcar'],
  ['RECLAMO_CLIENTE', 'Nos lo reclamó un cliente'],
  ['AUDITORIA', 'Salió en una auditoría'],
  ['PROVEEDOR', 'Es un problema del proveedor'],
];

export const SEVERIDADES_NC = [
  ['ALTA', 'Grave — llegó al cliente o pudo llegar'],
  ['MEDIA', 'Media — lo paramos a tiempo'],
  ['BAJA', 'Leve — sin consecuencias'],
];

export const DISPOSICIONES_NC = [
  ['RETRABAJO', 'Se retrabajó'],
  ['RETRABAJO_Y_REINSPECCION', 'Se retrabajó y se volvió a inspeccionar'],
  ['DESECHO', 'Se desechó'],
  ['USO_CON_CONCESION', 'Se usó como estaba, con concesión'],
  ['DEVOLUCION_PROVEEDOR', 'Se devolvió al proveedor'],
];

export const ESTADOS_NC_EDITABLES = [
  ['ABIERTA', 'Abierta — todavía no la ha mirado nadie'],
  ['EN_ANALISIS', 'En análisis — buscando por qué pasó'],
  ['EN_ACCION', 'En acción — arreglándolo'],
  ['EN_VERIFICACION', 'En verificación — comprobando que funcionó'],
];

// LAS OCHO DISCIPLINAS, con su etiqueta y una frase que dice qué va en
// cada una. Sin la frase, «D5» es una casilla vacía que cada quien llena
// con lo que cree; con ella, un 8D lo puede llenar alguien que no ha
// hecho ninguno antes — que es exactamente quien lo va a llenar aquí.
export const DISCIPLINAS_8D = [
  ['d1_equipo', 'D1 · Quién lo va a resolver',
   'Las personas que van a trabajar en esto. Con nombres, no con áreas.'],
  ['d2_descripcion', 'D2 · Qué pasó, con datos',
   '¿Qué falló, en cuántas piezas, desde cuándo y dónde se detectó?'],
  ['d3_contencion', 'D3 · Qué se hizo de inmediato',
   'Lo que se hizo para que no siguiera saliendo mientras se investigaba.'],
  ['d4_causa_raiz', 'D4 · Por qué pasó de verdad',
   'La conclusión de los porqués de abajo. No «error humano»: por qué fue posible el error.'],
  ['d5_acciones', 'D5 · Qué se va a hacer',
   'Lo que va a impedir que vuelva a pasar. Abajo se le pone responsable y fecha.'],
  ['d6_implementacion', 'D6 · Qué se hizo de verdad, y cuándo',
   'Lo que ya se ejecutó, con fechas. Es lo que distingue un plan de un hecho.'],
  ['d7_prevencion', 'D7 · Qué se cambió para que no vuelva',
   'El procedimiento, el plan de inspección o la rutina que se actualizó.'],
  ['d8_cierre', 'D8 · Cierre',
   'Cómo quedó, y el reconocimiento al equipo. Se llena solo al cerrar si lo dejas en blanco.'],
];


// ---------------------------------------------------------------------
// CALIDAD · Fase 5 · instrumentos
// ---------------------------------------------------------------------
export const ESTADOS_INSTRUMENTO_EDITABLES = [
  ['ACTIVO', 'En uso — se puede medir con él'],
  ['FUERA_DE_SERVICIO', 'Fuera de servicio — está en el laboratorio o en reparación'],
  ['BAJA', 'De baja — ya no existe'],
];

export const RESULTADOS_CALIBRACION = [
  ['CONFORME', 'Pasó'],
  ['AJUSTADO', 'Pasó, después de ajustarlo'],
  ['NO_CONFORME', 'No pasó'],
];

// EL INTERRUPTOR DE LA FASE 5 NO ES UN SÍ/NO, y por eso no está en
// `INTERRUPTORES` con los otros tres: son dos maneras distintas de
// tratar lo mismo, y «apagado» no significaría nada aquí.
export const MODOS_INSTRUMENTO_VENCIDO = [
  ['BLOQUEA', 'No dejar medir con él',
   'Si la calibración se pasó, TEGO no guarda la medida. Quien tenga el permiso de la excepción puede autorizarlo explicando por qué.'],
  ['AVISA', 'Dejar medir, pero anotarlo',
   'La medida se guarda y TEGO escribe en ella que el instrumento estaba vencido. Nadie tiene que autorizar nada.'],
];

// LA FECHA, DICHA COMPLETA. `fechaCorta` (en `documentos.js`) abrevia el
// mes —«12 oct 2026»—, que se lee bien en una lista larga de revisiones.
// Aquí las fechas son pocas y son la respuesta a la pregunta, así que se
// dicen enteras. Mediodía a propósito, por lo mismo que allí: con la
// fecha a las 00:00 UTC, un huso al oeste la enseñaría como el día
// anterior.
export function fechaLarga(v) {
  if (!v) return null;
  return new Intl.DateTimeFormat('es-MX', {
    day: '2-digit', month: 'long', year: 'numeric',
  }).format(new Date(`${String(v).slice(0, 10)}T12:00:00`));
}

// CUÁNTO FALTA, DICHO COMO SE DICE EN VOZ ALTA.
//
// VIVE AQUÍ Y NO EN LA PANTALLA para poder probarlo: la frase de un
// instrumento vencido tiene que decir RETRASO y no «vence en −9 días»,
// que es lo que sale de restar sin pensar. Y tiene que decir que no se
// puede medir con él, porque ése es el efecto y es lo que la persona
// necesita saber — no la aritmética.
export function cuantoFalta(i) {
  if (i.vigencia === 'SIN_CALIBRAR') {
    return 'Nunca se ha calibrado aquí. No se puede medir con él.';
  }
  if (i.dias === null || i.dias === undefined) return '';
  if (i.dias < 0) {
    const d = Math.abs(i.dias);
    return `Se pasó hace ${d} día${d === 1 ? '' : 's'}. No se puede medir con él.`;
  }
  if (i.dias === 0) return 'Vence hoy. Mándalo a calibrar.';
  // «Le quedan 1 día» es de las cosas que hacen que una pantalla parezca
  // escrita por una máquina. El verbo también concuerda, no solo el
  // sustantivo.
  if (i.dias === 1) return 'Le queda 1 día.';
  return `Le quedan ${i.dias} días.`;
}


// ---------------------------------------------------------------------
// CALIDAD · Fase 6 · el paquete de evidencia
// ---------------------------------------------------------------------
// LOS PERIODOS SE ELIGEN CON UN BOTÓN, no tecleando. «El trimestre
// pasado» es como se dice en voz alta con el auditor delante;
// «2026-01-01» es como lo escribe una máquina, y obliga a hacer cuentas
// de calendario en el peor momento. Los campos de fecha siguen ahí para
// quien quiera un periodo raro.
export const ATAJOS_PERIODO = [
  ['mes', 'El mes pasado'],
  ['trimestre', 'El trimestre pasado'],
  ['ano', 'Este año'],
  ['ano_pasado', 'El año pasado'],
];

const iso = (d) => d.toISOString().slice(0, 10);

// VIVE AQUÍ Y NO EN LA PANTALLA para poder probarlo. Un atajo que
// devuelve el trimestre equivocado produce un paquete cuya portada dice
// un periodo y cuyo contenido es otro — y eso, en una auditoría, no se
// distingue de haber escondido algo.
export function periodoDe(clave, hoy = new Date()) {
  const y = hoy.getFullYear();
  const m = hoy.getMonth();
  if (clave === 'mes') {
    return { desde: iso(new Date(Date.UTC(y, m - 1, 1))),
             hasta: iso(new Date(Date.UTC(y, m, 0))) };
  }
  if (clave === 'trimestre') {
    // El trimestre CERRADO anterior, no los últimos tres meses: un
    // auditor pide «el primer trimestre», no «desde el 14 de febrero».
    //
    // EN ENERO ESTO DA UN MES NEGATIVO, y está bien: `Date.UTC` lo
    // normaliza hacia atrás, así que `Date.UTC(2026, -3, 1)` es el 1 de
    // octubre de 2025, que es exactamente el trimestre que se pide. Aquí
    // hubo una rama `if (tri < 0)` que hacía esa cuenta a mano; se quitó
    // al comprobar rompiendo — romperla no ponía roja ninguna prueba
    // porque las dos versiones dan lo mismo, y una rama que no se puede
    // distinguir de su ausencia es una rama que nadie va a mantener bien.
    // Quien vigila esto es la prueba «en enero, el trimestre pasado es el
    // último del año anterior».
    const t = Math.floor(m / 3) - 1;
    return { desde: iso(new Date(Date.UTC(y, t * 3, 1))),
             hasta: iso(new Date(Date.UTC(y, t * 3 + 3, 0))) };
  }
  if (clave === 'ano_pasado') {
    return { desde: `${y - 1}-01-01`, hasta: `${y - 1}-12-31` };
  }
  return { desde: `${y}-01-01`, hasta: iso(new Date(Date.UTC(y, m, hoy.getDate()))) };
}
